<template>
  <header v-if="!$store.state.isWeixin" class="web-header">
    <div class="top"></div>
    <div class="control">
      <close-icon class="left" />
      {{ title }}
      <more-icon class="right" />
    </div>
  </header>
</template>
<script>
import CloseIcon from "@/assets/svg/icon_close.svg";
import MoreIcon from "@/assets/svg/icon_more.svg";
export default {
  data() {
    return {
      title: "点猫编程平台服务号",
    };
  },
  watch: {
    $route(val, oldVal) {
      this.setTitle(val.meta.title || "点猫编程平台服务号");
    },
  },
  methods: {
    setTitle(title) {
      this.title = title;
      document.title = title;
    },
  },
  components: {
    CloseIcon,
    MoreIcon,
  },
};
</script>
<style lang="stylus" scoped>
header
  position fixed
  z-index 99
  background-color white
  width 100%
  top 0
  left 0
.control
  line-height 44px
  display flex
  justify-content space-between
  align-items center
  flex-wrap nowrap
  font-size 18px
  color #333
  font-weight bold
.top
  height 20px
  background-color #f2f2f2
.left
  width 15px
  height 15px
  margin-left 15px
.right
  width 18px
  height 4px
  margin-right 15px
</style>
